var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorLocationDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1518 2.40234L11.8429 16.8098C11.8071 16.8865 11.7495 16.9514 11.6771 16.9969C11.6047 17.0425 11.5205 17.0667 11.4345 17.0667C11.3485 17.0667 11.2643 17.0425 11.1919 16.9969C11.1195 16.9514 11.062 16.8865 11.0261 16.8098L8.16751 11.2069L2.45024 8.40547C2.37205 8.37035 2.30578 8.31397 2.25932 8.24302C2.21287 8.17208 2.18817 8.08956 2.18817 8.00526C2.18817 7.92096 2.21287 7.83844 2.25932 7.76749C2.30578 7.69655 2.37205 7.64017 2.45024 7.60505L17.1518 2.40234Z",
    stroke: "white",
    strokeWidth: 0.784082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorLocationDoodle);
export default __webpack_public_path__ + "static/media/cursorLocationDoodle.1de749757f8c0b2d138fc2e5d4ca181a.svg";
export { ForwardRef as ReactComponent };